var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/NotEqualsSign.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const NotEqualSign = ({
  color = '#353B60',
  bgColor = 'inherit',
  ...other
}) => /*#__PURE__*/_jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: [/*#__PURE__*/_jsx("rect", {
    width: "24",
    height: "24",
    fill: bgColor
  }), /*#__PURE__*/_jsx("rect", {
    x: "6",
    y: "9",
    width: "12",
    height: "2",
    rx: "1",
    fill: color
  }), /*#__PURE__*/_jsx("rect", {
    x: "6",
    y: "13",
    width: "12",
    height: "2",
    rx: "1",
    fill: color
  }), /*#__PURE__*/_jsx("rect", {
    x: "11.5371",
    y: "5.73242",
    width: "13.322",
    height: "2",
    rx: "1",
    transform: "rotate(60 11.5371 5.73242)",
    fill: "white"
  }), /*#__PURE__*/_jsx("rect", {
    x: "9.53711",
    y: "5.73242",
    width: "13.322",
    height: "2",
    rx: "1",
    transform: "rotate(60 9.53711 5.73242)",
    fill: color
  })]
});